import React from 'react';
import { motion } from 'framer-motion';
export function ProblemReframe() {
  return <section className="py-24 px-6 max-w-2xl mx-auto" data-id="element-142">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="prose prose-lg prose-p:text-charcoal prose-headings:font-serif prose-headings:text-charcoal" data-id="element-143">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-144">
          The problem isn't you.
        </h2>

        <p className="text-xl text-center mb-12" data-id="element-145">
          It's that your day has{' '}
          <span className="font-bold text-terracotta border-b-2 border-terracotta/30" data-id="element-146">
            no locks
          </span>
          .
        </p>

        <p data-id="element-147">Solo-mom life creates:</p>
        <ul className="marker:text-muted-blue" data-id="element-148">
          <li data-id="element-149">Decision fatigue</li>
          <li data-id="element-150">Constant interruption</li>
          <li data-id="element-151">Overstimulation</li>
        </ul>

        <p data-id="element-152">
          So when the hardest windows hit (morning, re-entry, bedtime), you're
          trying to run your house on willpower.
        </p>

        <blockquote className="border-l-4 border-muted-blue pl-6 italic text-xl my-8 bg-muted-blue/5 py-4 pr-4 rounded-r-lg" data-id="element-153">
          And willpower is the first thing that dies when you're overstimulated.
        </blockquote>
      </motion.div>
    </section>;
}